exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-text-js": () => import("./../../../src/templates/text.js" /* webpackChunkName: "component---src-templates-text-js" */),
  "component---src-templates-tool-js": () => import("./../../../src/templates/tool.js" /* webpackChunkName: "component---src-templates-tool-js" */)
}

